import classNames from "classnames";
import type { ReactNode } from "react";
import Icon from "@/components/Icon";
import type { MaterialNames } from "@/components/material_symbol_names";

export interface TableCardProps {
  title: string;
  icon?: MaterialNames;
  children: ReactNode;
  testId?: string;
  bodyClassName?: string;
  /** Replaces the default compact-bleed / desktop-border shell when provided. */
  shellClassName?: string;
}

const tableBodyPadding =
  "[&_tbody_td]:px-2 [&_tbody_td:first-child]:pl-4 [&_tbody_td:last-child]:pr-4 [&_tbody_td:only-child]:px-4";

export const TABLE_CARD_BODY_PADDING = tableBodyPadding;

const defaultShellClassName = classNames(
  "w-full bg-sys-brand-surface max-lg:ml-[-1rem] max-lg:w-[calc(100%+2rem)] max-lg:min-w-0",
  "lg:overflow-hidden lg:rounded-lg lg:border lg:border-extended-pgadarknavy-brand-color"
);

export default function TableCard({ title, icon, children, testId, bodyClassName, shellClassName }: TableCardProps) {
  return (
    <section data-testid={testId ?? "table-card"} className={shellClassName ?? defaultShellClassName}>
      <div className="flex w-full items-center justify-between gap-2 px-4 pb-3 pt-4 lg:py-3">
        <h2 className="!m-0 text-title-medium-bold text-sys-brand-on-surface" data-testid="table-card-title">
          {title}
        </h2>
        {icon ? (
          <Icon name={icon} size={22} className="shrink-0 text-sys-brand-on-surface-variant" aria-hidden />
        ) : null}
      </div>
      <div className={classNames("max-w-full", tableBodyPadding, bodyClassName ?? "overflow-x-auto")}>{children}</div>
    </section>
  );
}
